<template>
    <textarea
        class="field__textarea scroll"
        v-model="model"
        @blur="action"
        @keyup.enter="action"
        spellcheck="true"
    >
    </textarea>
</template>

<script>
// packages
import { ref } from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

export default {
    props: {
        reset: Boolean,
        defaultValue: String
    },
    setup ( props, { emit }) {
        const model = ref( props.defaultValue );

        // listener para quando for necessário
        // proceder a um reset a input.
        reset({ props, object: model, key: 'value' });

        // emissão do valor da input para o
        // componente pai.
        const action = () => {
            emit( 'input-value', model.value );
        };

        return {
            model,
            action
        };
    }
};
</script>